var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getParticipantsWithPastShiftsAnalyticsFunctionDef, } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React from 'react';
import useSWR from 'swr';
export const singleParticipantDetailsAnalyticsFetchKey = 'singleParticipantDetailsAnalytics';
export function useSingleParticipantDetailsAnalytics({ row, participantId, isExpanded, missionId, }) {
    const getParticipantsWithPastShiftsAnalyticsPlatformFn = useTypedPlatformFunction(getParticipantsWithPastShiftsAnalyticsFunctionDef);
    const fetchParticipantsWithPastShiftsAnalytics = (participantId, missionId) => __awaiter(this, void 0, void 0, function* () {
        return yield getParticipantsWithPastShiftsAnalyticsPlatformFn({
            missionId,
            participantId,
        });
    });
    const fetchEmpty = (row) => {
        return new Promise((resolve) => {
            var _a;
            resolve({
                pendingHours: row.pendingHours,
                approvedHours: row.approvedHours,
                deniedHours: (_a = row.deniedHours) !== null && _a !== void 0 ? _a : 0,
                shifts: row.shifts,
            });
        });
    };
    const { data: analytics, mutate, isLoading, error, } = useSWR([singleParticipantDetailsAnalyticsFetchKey, missionId, participantId, row, isExpanded], ([, paramsMissionId, paramsParticipantId, paramsRow, paramsIsExpanded]) => {
        return paramsIsExpanded
            ? fetchParticipantsWithPastShiftsAnalytics(paramsParticipantId, paramsMissionId).catch(handleErrorSnackbar)
            : fetchEmpty(paramsRow);
    }, defaultFetcherOptions);
    const fetchAnalytics = React.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield mutate();
    }), [mutate]);
    return {
        fetchAnalytics,
        data: Object.assign(Object.assign({}, row), analytics),
        error,
        isLoading,
    };
}
